<script>
import constant from '@constants/constant'
import accesslevels from '@utils/accesslevels'
import { vodReportMethods, toasterMethods } from '@state/helpers'
export default {
  props: {
    customerId: {
      type: [Number, String],
      default: '',
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      icon: '',
      uploadModal: false,
      confirmTitle: constant.imageHeaderConf,
      confirmMessage: constant.cancelConfirmationMessage,
      showModalConfirm: false,
      docUpload: false,
      fieldDisable: false,
      rowCount: 0,
      // showSuccessModalAlert: false,
      // showModalAlert: false,
      showUploadModalAlert: false,
      alertMessage: '',
      messageType: '',
      showSpinner: false,
      custUserId: '',
      referenceNumber: '',
      borrowerFirstName: '',
      borrowerLastName: '',
      borrowerSSN: '',
      coborrowerFirstName: '',
      coborrowerLastName: '',
      coborrowerSSN: '',
      financialInstitution: '',
      phoneNumber: '',
      emailAddress: '',
      streetAddress: '',
      cityName: '',
      stateName: '',
      zip: '',
      accntNo: [],
      accntType: [],
      selectedAccountName: [],
      jointAccountName: '',
      otherName: [],
      eachBalance: [],
      AccntDetails: [],
      coborrower: false,
      additionalNotes: '',
      signedFileName: '',
      signedfile: null,
      isAuthFormRequired: true,
      AuthorizationError: '',
      dropdownOptions: '',
      disableField: [],
      errorList: [],
      errorListA: [],
      errorListB: [],
      errorListC: [],
      errorListD: [],
      authorizedFileItems: [{ file_name: 'dssdsdsd', file_actions: '' }],
      authorizedTableFields: [
        { key: 'file_name', label: 'File Name', class: 'text-left' },
        { key: 'file_actions', label: 'Actions' },
      ],
      accountColumnsDefinition: [
        { key: 'accountNumber', label: 'Account Number *', sortable: false },
        { key: 'accountType', label: 'Account Type *', sortable: false },
        { key: 'accountName', label: 'Name on the Account *', sortable: false },
        { key: 'otherNames', label: 'Other Name(s)', sortable: false },
        { key: 'balance', label: 'Balance *', sortable: false },
        { key: 'actions', label: 'Delete', sortable: false },
      ],
      dropdownOptionsInitial: [
        { text: 'Borrower', value: 'Borrower' },
        { text: 'Other (Please Specify)', value: 'Other (Please Specify)' },
      ],
      accountTableData: [
        {
          accountNumber: '',
          accountType: [
            { text: 'Certificate Of Deposit', value: 'Certificate Of Deposit' },
            { text: 'Checking', value: 'Checking' },
            { text: 'IRA', value: 'IRA' },
            { text: 'Money Market', value: 'Money Market' },
            { text: 'Savings', value: 'Savings' },
          ],
          accountName: [],
          otherNames: '',
          balance: '',
          actions: false,
        },
      ],
    }
  },
  computed: {
    placeholders() {
      return {
        referenceNumber: 'Reference Number',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        ssn: 'xxx-xx-xxxx',
        financialInstitution: 'Financial Institution',
        phoneNumber: '(xxx) xxx-xxxx',
        email: 'Email ID',
        streetAddress: 'Street Address',
        cityName: 'City Name',
        zip: 'xxxxx-xxxx',
        accntNo: 'Account Number',
        otherName: 'Other Name',
        eachBalance: 'Balance',
      }
    },
    states() {
      return this.$_allStates
    },
    isCustRequestor() {
      return accesslevels(9)
    },
    isCustProcessor() {
      return accesslevels(8)
    },
    CURRENT_USER() {
      return this.$store.state.auth.currentUser
        ? this.$store.state.auth.currentUser.userInfo || {}
        : {}
    },
  },
  created() {
    this.messageType = constant.imageHeaderError
    this.alertMessage = constant.emptyPdfFile
    this.dropdownOptions = this.dropdownOptionsInitial
    let i
    for (i = 0; i < 3; i++) {
      this.disableField[i] = true
      this.errorListA[i] = true
      this.errorListB[i] = true
      this.errorListC[i] = false
      this.errorListD[i] = false
      this.errorList[i] = true
      this.selectedAccountName[i] = 'Borrower'
    }
  },
  methods: {
    ...vodReportMethods,
    ...toasterMethods,
    isDocumentUploaded() {
      if (!this.fileData) {
        this.showUploadModalAlert = true
        return false
      } else {
        return true
      }
    },
    confirmClicked() {
      this.showUploadModalAlert = false
    },
    constructAccountDetails() {
      let i
      for (i = 0; i <= this.rowCount; i++) {
        if (this.selectedAccountName[i] === 'Joint') {
          this.jointAccountName =
            this.borrowerFirstName +
            ' ' +
            this.borrowerLastName +
            ' ' +
            this.coborrowerFirstName +
            ' ' +
            this.coborrowerLastName
        } else {
          this.jointAccountName = this.selectedAccountName[i]
        }
        if (this.selectedAccountName[i] !== 'Other (Please Specify)') {
          this.otherName[i] = null
        }
        if (this.selectedAccountName[i] === 'Other (Please Specify)') {
          this.jointAccountName = null
        }
        if (this.selectedAccountName[i] === 'Borrower') {
          this.jointAccountName =
            this.borrowerFirstName + ' ' + this.borrowerLastName
        }
        if (this.selectedAccountName[i] === 'Co-Borrower') {
          this.jointAccountName =
            this.coborrowerFirstName + ' ' + this.coborrowerLastName
        }
        this.AccntDetails.push({
          accountNo: this.accntNo[i],
          accountType: this.accntType[i],
          nameOnTheAccount: this.jointAccountName,
          otherNames: this.otherName[i],
          balance: this.eachBalance[i],
        })
      }
      return this.AccntDetails
    },
    buildVODRequest() {
      if (!this.coborrower) {
        this.coborrowerFirstName = null
        this.coborrowerLastName = null
        this.coborrowerSSN = null
      }
      this.custUserId = this.isCustRequestor
        ? this.CURRENT_USER.userId
        : this.customerUserId
      this.customerId =
        this.isCustProcessor || this.isCustRequestor
          ? this.CURRENT_USER.customerId
          : this.customerId
      this.fileData = this.fileData.replace('data:application/pdf;base64,', '')
      return JSON.stringify({
        userId: this.CURRENT_USER.userId,
        ProductId: this.productId,
        orderForUser: this.custUserId,
        orderForCustomer: this.customerId,
        borrowerFirstName: this.borrowerFirstName,
        borrowerLastName: this.borrowerLastName,
        borrowerSSN: this.borrowerSSN,
        referenceNo: this.referenceNumber,
        FinancialInstituteAddress: this.streetAddress,
        borrowerCityName: this.cityName,
        borrowerState: this.stateName,
        borrowerZip: this.zip,
        CoBorrowerFirstName: this.coborrowerFirstName,
        CoBorrowerLastName: this.coborrowerLastName,
        CoBorrowerSSN: this.coborrowerSSN,

        accountdetails: this.constructAccountDetails(),

        financialInstitute: this.financialInstitution,
        FinancialEmailId: this.emailAddress,
        FinancialPhoneNumber: this.phoneNumber,
        additionalNote: this.additionalNotes,
        vodFileViewModel: {
          FileName: this.fileName,
          ReportByteArray: this.fileData,
        },
      })
    },
    onVODReportSubmit() {
      var isOrderReportComponentValid = false
      var isVoEReportComponentValid = false
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (this.isCustRequestor) {
            isOrderReportComponentValid = response
          }
          isVoEReportComponentValid = response
          if (
            isOrderReportComponentValid &&
            isVoEReportComponentValid &&
            that.isDocumentUploaded()
          ) {
            this.showSpinner = true
            that
              .generateVoDreports(that.buildVODRequest())
              .then((response) => {
                let respData = response.data || response
                let responseID = response.orderId || response.data.orderId
                let responseMsg = `${responseID} for Manual Verification of Deposit submitted successfully`
                if (respData.orderId !== undefined) {
                  this.setAlert({
                    title: constant.imageHeaderSuccess,
                    msg: responseMsg,
                    variant: constant.successMessagetype,
                  })
                }
                this.showSpinner = false
              })
              .catch((error) => {
                this.showSpinner = false
                this.autherror = error
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
              })
              .finally(() => this.$emit('resetOrderReport'))
          }
        })
      })
    },
    dropValue(key) {
      if (this.selectedAccountName[key] === 'Other (Please Specify)') {
        this.disableField[key] = false
        this.errorListD[key] = true
      } else {
        this.disableField[key] = true
        this.otherName[key] = ' '
        this.errorListD[key] = false
      }
    },
    handleError(field, key) {
      switch (field) {
        case 'balance':
          if (this.eachBalance[key]) {
            this.errorList[key] = false
          } else {
            this.errorList[key] = true
          }
          break
        case 'accountNumber':
          if (this.accntNo[key]) {
            this.errorListA[key] = false
          } else {
            this.errorListA[key] = true
          }
          break
        case 'accountType':
          if (this.accntType[key]) {
            this.errorListB[key] = false
          } else {
            this.errorListB[key] = true
          }
          break
        case 'accountName':
          if (this.selectedAccountName[key]) {
            this.errorListC[key] = false
          } else {
            this.errorListC[key] = true
          }
          break
        case 'otherNames':
          if (this.otherName[key]) {
            this.errorListD[key] = false
          } else {
            this.errorListD[key] = true
          }
          break
      }
    },
    toggleEventParent: function() {
      this.coborrower = !this.coborrower
      if (this.coborrower) {
        this.dropdownOptions = [
          { text: 'Borrower', value: 'Borrower' },
          { text: 'Co-Borrower', value: 'Co-Borrower' },
          { text: 'Joint', value: 'Joint' },
          { text: 'Other (Please Specify)', value: 'Other (Please Specify)' },
        ]
      } else {
        this.dropdownOptions = this.dropdownOptionsInitial
      }
    },
    showUploadModal() {
      this.docUpload = false
      this.uploadModal = true
    },
    hideModalBox() {
      this.uploadModal = false
      this.docUpload = true
    },
    onCancelClick() {
      this.showModalConfirm = true
    },
    onCancelConfirm() {
      this.$emit('resetOrderReport')
    },
    hideModalAlert() {
      this.showModalConfirm = false
    },
    onChangePdf(e) {
      this.showSpinner = true
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        // alert(constant.emptyPdf)
        this.setAlert({
          title: constant.imageHeaderError,
          msg: constant.emptyPdf,
          variant: constant.errorMessagetype,
        })
        return
      }

      if (files[0].type !== 'application/pdf') {
        // alert('Invalid file type, please upload a valid file.')
        this.setAlert({
          title: constant.imageHeaderError,
          msg: 'Invalid file type, please upload a valid file.',
          variant: constant.errorMessagetype,
        })

        this.uploadModal = false
        this.showSpinner = false
        return
      }

      if (files[0].size > 5242880) {
        // alert(constant.fileSizeMessage_5MB)
        this.setAlert({
          title: constant.imageHeaderError,
          msg: constant.fileSizeMessage_5MB,
          variant: constant.errorMessagetype,
        })

        this.isDisabled = false
        this.showSpinner = false
        this.signedFileName = ''
        return
      }
      this.signedFileName = this.signedfile.name
      this.authorizedFileItems[0].file_name = this.signedFileName
      this.fileType = files[0].type
      this.ConvertToBase64(files[0])
      this.isDisabled = true
    },
    f(pdf) {
      this.fileItemsTable.push({ file_name: pdf.name })
      this.$refs.modaldoc.style.display = 'none'
    },
    ConvertToBase64(pdf) {
      var fileReader = new FileReader()
      this.fileName = pdf.name
      var current = this
      fileReader.readAsDataURL(pdf)
      fileReader.onload = function(event) {
        current.fileData = event.target.result
        current.AuthorizationError = ''
        current.showSpinner = false
      }
    },
    clearFiles(index) {
      this.signedFileName = ''
      this.fileData = ''
      this.fileType = ''
      this.fileName = ''
      this.signedfile = null
      this.isDisabled = false
    },
    onAddTaxRow() {
      if (this.accountTableData.length < 3) {
        this.accountTableData.push(this.accountTableData[0])
        this.rowCount++
      } else {
        this.fieldDisable = true
      }
    },
    onDelTaxRow(event) {
      if (this.accountTableData.length > 1) {
        this.accountTableData.splice(1, 1)
        this.rowCount--
        this.fieldDisable = false
      }
    },
  },
}
</script>

<template>
  <section>
    <BaseSpinner v-if="showSpinner" />
    <BaseModalAlert
      :modal-show="showUploadModalAlert"
      :title-header="messageType"
      :alert-message="alertMessage"
      @confirmClicked="confirmClicked"
    ></BaseModalAlert>
    <!-- <BaseModalAlert
      :modal-show="showModalAlert"
      :title-header="messageType"
      :alert-message="alertMessage"
      @confirmClicked="confirmClicked"
    ></BaseModalAlert> -->
    <!-- <BaseModalAlert
      :modal-show="showSuccessModalAlert"
      :title-header="messageType"
      :alert-message="alertMessage"
      @confirmClicked="confirmClicked"
    ></BaseModalAlert> -->
    <b-row class="mt-2 mb-3">
      <b-col md="3">
        <BaseEInputText
          id="referenceNumber"
          v-model="referenceNumber"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          type="text"
          name="referenceNumber"
          maxlength="50"
          label-content="Reference Number"
          :placeholder="placeholders.referenceNumber"
        ></BaseEInputText>
      </b-col>
    </b-row>
    <b-row align-v="center">
      <b-col md="auto">
        <BaseELabel label="Borrower Information" size="md" />
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="borrowerFirstName"
          v-model="borrowerFirstName"
          v-validate="{ required: true }"
          data-vv-as="First Name"
          type="text"
          name="borrowerFirstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('borrowerFirstName'),
          }"
          :placeholder="placeholders.firstName"
          aria-describedby="firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('borrowerFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="borrowerLastName"
          v-model="borrowerLastName"
          v-validate="{ required: true }"
          data-vv-as="Last Name"
          type="text"
          name="borrowerLastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('borrowerLastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('borrowerLastName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="borrowerSSN"
          v-model="borrowerSSN"
          v-validate="{
            required: true,
            regex: /^\d{3}-?\d{2}-?\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          type="text"
          maxlength="11"
          name="borrowerSSN"
          label-content="SSN"
          data-vv-as="SSN"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('borrowerSSN'),
          }"
          :placeholder="placeholders.ssn"
        />
        <div class="error">
          {{ errors.first('borrowerSSN') }}
        </div>
      </b-col>
    </b-row>
    <b-row align-v="center" class="pt-2">
      <b-col md="auto">
        <BaseELabel label="Co-Borrower Information" size="md" />
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col class="mt-2">
        <BaseSwitch
          id="coborrower"
          v-model="coborrower"
          name="coborrower"
          class="float-left pt-2"
          checkedlbl="Yes"
          uncheckedlbl="No"
          :is-checked="coborrower"
          @toggleEvent="toggleEventParent"
        />
      </b-col>
    </b-row>
    <b-row v-show="coborrower">
      <b-col md="3">
        <BaseEInputText
          id="coborrowerFirstName"
          v-model="coborrowerFirstName"
          v-validate="{ required: coborrower ? true : false }"
          data-vv-as="First Name"
          type="text"
          name="coborrowerFirstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('coborrowerFirstName'),
          }"
          :placeholder="placeholders.firstName"
          aria-describedby="firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('coborrowerFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="coborrowerLastName"
          v-model="coborrowerLastName"
          v-validate="{ required: coborrower ? true : false }"
          data-vv-as="Last Name"
          type="text"
          name="coborrowerLastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('coborrowerLastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('coborrowerLastName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="coborrowerSSN"
          v-model="coborrowerSSN"
          v-validate="{
            required: coborrower ? true : false,
            regex: /^\d{3}-?\d{2}-?\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          type="text"
          maxlength="11"
          name="coborrowerSSN"
          label-content="SSN"
          data-vv-as="SSN"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('coborrowerSSN'),
          }"
          :placeholder="placeholders.ssn"
        />
        <div class="error">
          {{ errors.first('coborrowerSSN') }}
        </div>
      </b-col>
    </b-row>
    <b-row align-v="center" class="pt-2">
      <b-col md="auto">
        <BaseELabel label="Depository Information" size="md" />
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="financialInstitution"
          v-model="financialInstitution"
          v-validate="{ required: true }"
          data-vv-as="Financial Institution"
          type="text"
          name="financialInstitution"
          maxlength="50"
          label-content="Financial Institution"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('financialInstution'),
          }"
          :placeholder="placeholders.financialInstitution"
          aria-describedby="firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('financialInstitution') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="phoneNumber"
          v-model="phoneNumber"
          v-validate="{
            required: true,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          mark-required
          data-vv-as="Phone Number"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('phoneNumber') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="emailAddress"
          v-model="emailAddress"
          v-validate="{
            required: true,
            regex: /\S+@\S+\.\S+/,
          }"
          maxlength="50"
          type="text"
          name="emailAddress"
          label-content="Email ID"
          data-vv-as="Email ID"
          mark-required
          :placeholder="placeholders.email"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('emailAddress') }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          v-validate="{
            required: false,
          }"
          type="text"
          name="streetAddress"
          maxlength="150"
          label-content="Street Address"
          data-vv-as="Street"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: false, regex: /^[A-Za-z-.() ]+$/ }"
          validattor="^[A-Za-z-. ]+$"
          type="text"
          name="cityName"
          maxlength="50"
          label-content="City"
          data-vv-as="City"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
      </b-col>
      <b-col md="2">
        <BaseELabel label="State" />
        <BaseDropdown
          id="stateName"
          v-model="stateName"
          :field-id="stateName"
          :options="states"
          class="mb-1 mt-1"
          name="stateName"
          :placeholder="placeholders.stateName"
        ></BaseDropdown>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: false }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          data-vv-as="Zip"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pt-3 ml-md-auto">
        <div class="col-md-12 text-right pr-0">
          <b-button
            id="tooltip-target-2"
            class=" d-inline-block mr-1"
            :disabled="fieldDisable"
            size="md"
            variant="outline-dark"
            @click="onAddTaxRow"
            >New
            <BaseIcon name="plus" class="ml-1"> </BaseIcon>
          </b-button>
          <b-button
            id="tooltip-target-1"
            class="btn"
            :class="$style.iconbutton"
          >
            <BaseIcon
              v-model="icon"
              class="d-inline-block"
              name="info-circle"
            />
          </b-button>
          <b-tooltip target="tooltip-target-1" triggers="hover">
            Maximum of 3 Accounts can be Added
          </b-tooltip>
          <b-tooltip target="tooltip-target-2" triggers="hover">
            Add Row
          </b-tooltip>
        </div>
      </b-col>
    </b-row>
    <b-row class="pt-3">
      <b-col class="mt-1">
        <div class="text-center">
          <b-table
            id="taxTabel"
            hover
            striped
            bordered
            :items="accountTableData"
            :fields="accountColumnsDefinition"
          >
            <template v-slot:cell(accountNumber)="row">
              <BaseEInputText
                :id="accntNo[row.index]"
                v-model="accntNo[row.index]"
                v-validate="{
                  required: errorListA[row.index] ? true : false,
                }"
                maxlength="20"
                type="text"
                :name="row.index + '0'"
                class="pt-1"
                data-vv-as="Account number"
                :placeholder="placeholders.accntNo"
                @input="handleError('accountNumber', row.index)"
              >
              </BaseEInputText>
              <div v-if="!accntNo[row.index]" class="error">
                {{ errors.first(row.index + '0') }}
              </div>
            </template>
            <template v-slot:cell(accountType)="row">
              <BaseDropdown
                :id="accntType[row.index]"
                v-model.lazy="accntType[row.index]"
                v-validate="{
                  required: errorListB[row.index] ? true : false,
                }"
                :field-id="accntType[row.index]"
                :options="row.item.accountType"
                data-vv-as="Account type"
                class="pt-1"
                :name="row.index + '1'"
                @change="handleError('accountType', row.index)"
              ></BaseDropdown>
              <div v-if="!accntType[row.index]" class="pt-1 error">
                {{ errors.first(row.index + '1') }}
              </div>
            </template>
            <template v-slot:cell(accountName)="row">
              <BaseDropdown
                :id="selectedAccountName[row.index]"
                :key="selectedAccountName.id"
                v-model="selectedAccountName[row.index]"
                v-validate="{ required: errorListC[row.index] ? true : false }"
                :field-id="selectedAccountName[row.index]"
                :options="dropdownOptions"
                data-vv-as="Account name"
                class="pt-1"
                :name="row.index + '2'"
                @click="dropValue(row.index)"
                @change="handleError('accountName', row.index)"
              ></BaseDropdown>
              <div v-if="!selectedAccountName[row.index]" class="pt-1 error">
                {{ errors.first(row.index + '2') }}
              </div>
            </template>
            <template v-slot:cell(otherNames)="row">
              <BaseEInputText
                :id="otherName[row.index]"
                v-model="otherName[row.index]"
                v-validate="{ required: errorListD[row.index] ? true : false }"
                maxlength="50"
                type="text"
                :name="row.index + '3'"
                class="pt-1"
                :is-disabled="disableField[row.index]"
                data-vv-as="Other Name(s)"
                :placeholder="placeholders.otherName"
                @change="handleError('otherNames', row.index)"
              >
              </BaseEInputText>
              <div v-if="errorListD[row.index]" class="error">
                {{ errors.first(row.index + '3') }}
              </div>
            </template>
            <template v-slot:cell(balance)="row">
              <BaseEInputText
                :id="eachBalance[row.index]"
                v-model="eachBalance[row.index]"
                v-validate="{ required: errorList[row.index] ? true : false }"
                validattor="[0-9]"
                maxlength="15"
                type="text"
                :name="row.index + '4'"
                class="pt-1"
                data-vv-as="Balance"
                :placeholder="placeholders.eachBalance"
                @input="handleError('balance', row.index)"
              >
              </BaseEInputText>
              <div v-if="!eachBalance[row.index]" class="error">
                {{ errors.first(row.index + '4') }}
              </div>
            </template>
            <template v-slot:cell(actions)="row">
              <b-form-group class="pt-2 text-center">
                <BaseIcon
                  v-model="row.item.actions"
                  name="times-circle"
                  :class="$style.delActionBtn"
                  @click="onDelTaxRow"
                />
              </b-form-group>
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
    <b-row align-v="center">
      <b-col md="auto">
        <BaseELabel
          label="Borrower's Authorization Form"
          :mark-required="isAuthFormRequired"
          size="md"
        />
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col class="text-right my-2">
        <BaseEButton variant="cancel" @click="showUploadModal">
          Upload Document
        </BaseEButton>
      </b-col>
      <b-col md="12">
        <b-table
          id="tblBorrowerAuthorization"
          class="text-center"
          hover
          striped
          bordered
          responsive="sm"
          :items="docUpload ? authorizedFileItems : null"
          :fields="authorizedTableFields"
        >
          <template v-slot:cell(file_name)>
            <b class="text-info">{{ signedFileName }} </b>
          </template>
          <template v-slot:cell(file_actions)="data">
            <div class="text-center">
              <BaseIcon
                v-model="data.value"
                name="times-circle"
                :class="$style.delActionBtn"
                @click="clearFiles"
              />
            </div>
          </template>
        </b-table>
      </b-col>
      <b-col md="12">
        <div class="error">
          {{ AuthorizationError }}
        </div>
      </b-col>
    </b-row>
    <b-row class="pb-3 mt-2 border-bottom">
      <b-col>
        <BaseTextarea
          id="additionalNotes"
          v-model="additionalNotes"
          v-validate="{ required: false }"
          maxlength="500"
          name="comments"
          label-content="Additional Notes"
        ></BaseTextarea>
      </b-col>
    </b-row>
    <b-row class="mt-4" align-h="start">
      <BaseEButton @click="onVODReportSubmit">
        Order
      </BaseEButton>
      <BaseEButton variant="cancel" @click="onCancelClick">Cancel</BaseEButton>
    </b-row>
    <BaseModalLayout
      :show-modal="uploadModal"
      modal-title="Upload Authorization Form"
      modal-size="lg"
      ok-variant="Upload"
      cancel-variant="Cancel"
      @confirmOkClicked="hideModalBox"
      @confirmCancelClicked="uploadModal = false"
    >
      <b-row class="pt-2">
        <b-col>
          <BaseELabel
            label="Upload file ( Support .pdf) Max size is 5 MB"
            class="text-left"
          />
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col>
          <div class="d-block text-center">
            <div>
              <b-form-file
                id="signedfile"
                ref="file-input"
                v-model="signedfile"
                :validate="'required'"
                accept="application/pdf, image/tiff, image/tif"
                placeholder="example_filename.pdf"
                drop-placeholder="Drop file here..."
                class="text-left"
                :class="$style.textellipsis"
                @change.native="onChangePdf"
              ></b-form-file>
            </div>
          </div>
        </b-col>
      </b-row>
    </BaseModalLayout>
    <BaseModalLayout
      :show-modal="showModalConfirm"
      :modal-title="confirmTitle"
      modal-size="md"
      ok-variant="Ok"
      cancel-variant="Cancel"
      @confirmOkClicked="onCancelConfirm"
      @confirmCancelClicked="hideModalAlert"
    >
      <b-row class="my-4 textContent">
        {{ confirmMessage }}
      </b-row>
    </BaseModalLayout>
  </section>
</template>

<style lang="scss" module>
@import '@design';
.status {
  margin: 0.625rem 0;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}

.labelHeader {
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
// .cancelBtn {
//   font-weight: 600 !important;
//   color: $color-button-bg !important;
//   text-shadow: 0;
//   background-color: $color-button-text !important;
//   border: 1px solid $color-button-bg;
//   box-shadow: 0;
// }
.iconbutton,
.iconbutton:hover {
  color: #000 !important;
  background-color: #fff !important;
  border-color: #fff !important;
}
</style>
